export const tinkIncome = {
  100: '#F5FBF8',
  200: '#EAF7F0',
  300: '#D7F0E3',
  400: '#C2E8D4',
  500: '#9AD9B8',
  600: '#36B472',
  700: '#157C46',
  800: '#054A26',
  900: '#002713',
};
